import { render, staticRenderFns } from "./process-special-pii-categories.vue?vue&type=template&id=0212cd74"
import script from "./process-special-pii-categories.vue?vue&type=script&lang=js"
export * from "./process-special-pii-categories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports